import Vue from 'vue';
import VueI18n, {LocaleMessages} from 'vue-i18n';
import axios from 'axios';

Vue.use(VueI18n);

export const i18n = new VueI18n({

    locale: '',

    fallbackLocale: 'sv',

    messages: {  }
});

function setI18nLang ( lang: string ) {

  lang = (lang || 'sv').split('-')[0];

  i18n.locale = (lang || 'sv').split('-')[0];

  axios.defaults.headers.common['Accept-Language'] = lang;

  document.querySelector( 'html' )?.setAttribute( 'lang', lang );
}

function loadLocaleMessages (): LocaleMessages {

  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);

  const messages: LocaleMessages = {};

  locales.keys().forEach(key => {

    const matched = key.match(/([A-Za-z0-9-_]+)\./i)

    if (matched && matched.length > 1) {

      const locale = matched[1];

      messages[locale] = locales(key)
    }
  });

  return messages;
}

export const loadUserLanguageOrDefault = async () => {

  const localeMessages = loadLocaleMessages();

  let language = (navigator.language || 'sv').split('-')[0];

  language = localeMessages[language] ? language : 'en';

  i18n.setLocaleMessage(language, localeMessages[language]);

  setI18nLang(language);
};
